export enum FormModes {
  OnChange = 'onChange',
  OnSubmit = 'onSubmit',
  OnBlur = 'onBlur',
  OnAll = 'onAll',
  OnTouched = 'onTouched',
}
